
    import {Options, Inject, Vue} from 'vue-property-decorator';
    import {RouteNames} from '@/brief-hub/router/route-names';
    import {DI} from '@/brief-hub/config/DependencyInjection';
    import {NavigationService} from '@/brief-hub/brief/NavigationService';
    import {Getter} from 'vuex-class';
    import BriefResource from '@/brief-hub/brief/BriefResource';

    const steps = [
        {
            number: 1,
            routes: [
                RouteNames.BRIEF_NEW,
                RouteNames.BRIEF_FREELANCER_PROFILE,
                RouteNames.BRIEF_FREELANCER_JOB_TITLE,
                RouteNames.BRIEF_FREELANCER_SKILLS,
            ],
        },
        {number: 2, routes: [RouteNames.BRIEF_WHEN_CONDITIONS, RouteNames.BRIEF_WHERE_CONDITIONS]},
        {number: 3, routes: [RouteNames.BRIEF_MISSION_DESCRIPTION]},
        {number: 4, routes: [RouteNames.BRIEF_OVERVIEW]},
    ];

    @Options({})
    export default class ProgressTrackerV2 extends Vue {
        @Inject({from: DI.navigationService})
        navigationService!: NavigationService;

        @Getter('brief')
        brief!: BriefResource;

        get currentStepNumber(): number {
            const step = steps.find(({routes}) => routes.find((route) => this.$route.name === route));

            return step ? step.number : 1;
        }

        get currentSubStepNumber(): number {
            return this.$route.name ? steps[this.currentStepNumber - 1].routes.indexOf(this.$route.name as string) + 1 : 1;
        }
    }
